module.exports = __webpack_public_path__ + "img/vaginal-ring.d75800c6.png";